module.exports = __webpack_public_path__ + "static/nike-logo-fbfb09b585683743fcd2297bd681ab16.svg";